module.exports = __webpack_public_path__ + "media/country_flags/rs-22093ad7.png";